import { moveItemInArray } from "@angular/cdk/drag-drop";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { DirtyCheckComponent } from "src/app/_models/dirty-check.component";
import { DateUtilsService } from "src/app/_services/dateUtils";
import { InvoiceService } from "./../../../../_services/invoice.service";

@Component({
  selector: "app-ledger-preview",
  templateUrl: "./ledger-preview.component.html",
  styleUrls: ["./ledger-preview.component.scss"],
})
export class LedgerPreviewComponent implements OnInit, DirtyCheckComponent {
  docs: any;
  invoiceDetails: any;
  closeResult: string = "";
  modalOptions: NgbModalOptions;
  loading: boolean = false;
  uploadSuccessful: boolean = false;
  saving: boolean = false;
  uploadInvoice: boolean = false;
  displayName: any;
  hasError: boolean = false;
  imgUrl: string = "";
  typeError: boolean = false;
  sizeError: boolean = false;
  fileTypeError: boolean = false;
  fileSizeError: boolean = false;
  invoiceSaved: boolean = false;
  savingError: boolean = false;
  validationError: boolean = false;
  serverError: boolean = false;
  supportingDocuments: any[] = [];
  agreed = [{ status: false }];
  masterData: any;
  responseData: any;
  isError = false;
  vendorData: any;
  pdfSrc: any;
  invoiceFile: any;
  invoiceDataToSave: any;
  isInvoiceChange: boolean = false;
  isUpdatedData: boolean = false;
  invoiceChanged: boolean = false;
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  barcodeNo: any;
  eLoaderMsg = "";
  formSubmitted = false;
  previousUrl: any;
  companies: any;
  organisations: any;
  configResCompanies: any;
  configResOrg: any;
  configResDocs: any;
  totalSizeError = false;
  files: File[];
  supportingDocsAdded = false;
  canSubmitForm = false;
  allDeleted = false;

  extractedledger = new FormGroup({
    invoiceType: new FormControl("e-invoice"),
    file: new FormControl(null),

    //reuploadFile: new FormControl(null),
    supportingFiles: new FormControl([]),
    fileSource: new FormControl(""),
    documentSource: new FormControl(""),
    terms_agreed: new FormControl(false),
    emailAddress: new FormControl(null, [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
    username: new FormControl(""),
    userID: new FormControl(""),
    companyCode: new FormControl(null, [Validators.required]),
    purchaseOrg: new FormControl(null, [Validators.required]),
    docType: new FormControl(null, [Validators.required]),
  });

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private invoiceService: InvoiceService,
    private dateUtils: DateUtilsService,
    private authService: AuthService
  ) {
    this.modalOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      scrollable: true,
    };

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.previousUrl = val.url;
      }
    });
  }

  canDeactivate() {
    if (!this.formSubmitted) {
      this.loading = true;
      return false;
    } else {
      return true;
    }
  }

  exitForm() {
    this.loading = false;
    this.formSubmitted = true;
    this.previousUrl = this.route.snapshot.queryParams["returnUrl"] || "dashboard";
    //const returnUrl = this.route.snapshot.queryParamMap["returnUrl"];
    console.log(this.previousUrl);
    this.router.navigateByUrl(this.previousUrl);
  }

  cancelExit() {
    this.loading = false;
  }

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  selectDocuments(event: any) {
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
    const MAX_TOTAL_SIZE = 25 * 1024 * 1024; // 25MB
    const ALLOWED_TYPES = ["application/pdf"];

    this.files = Array.from(event);
    // Calculate the total size of the selected files (in bytes)
    const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

    // Check if the total size exceeds 25 MB
    if (totalSize > MAX_TOTAL_SIZE) {
      this.totalSizeError = true;
      this.sizeError = false;
      this.typeError = false;
    }

    for (const file of this.files) {
      // Check if any individual file size exceeds 5 MB
      if (file.size > MAX_FILE_SIZE) {
        this.sizeError = true;
        this.typeError = false;
        this.totalSizeError = false;
        continue;
      }

      // Filter out any files that are not Word, Excel, or PDF
      if (!ALLOWED_TYPES.includes(file.type)) {
        this.typeError = true;
        this.sizeError = false;
        this.totalSizeError = false;
        continue;
      }
      this.supportingDocuments.push(file);
    }

    if (this.allDeleted === true) {
      if (this.extractedledger.get("terms_agreed").value === true) {
        this.extractedledger.patchValue({
          terms_agreed: false,
        });
      }
    } else {
      this.extractedledger.patchValue({ terms_agreed: false });
    }

    this.supportingDocsAdded = true;
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.supportingDocuments.splice(index, 1);

    if (this.supportingDocuments.length === 0) {
      if (this.extractedledger.get("terms_agreed").value === true) {
        this.extractedledger.patchValue({
          terms_agreed: false,
        });
      }

      this.canSubmitForm = false;
      this.allDeleted = true;
      this.supportingDocsAdded = false;
    }
  }

  checkSupportingDocuments() {
    if (this.supportingDocuments.length > 0 && this.extractedledger.get("terms_agreed").value === false) {
      this.canSubmitForm = true;
    } else {
      this.canSubmitForm = false;
    }
  }

  reUploadInvoice(event: any) {
    if (event.length > 0) {
      const fileUploaded = event[0];

      //console.log(fileUploaded);

      if (fileUploaded.type !== "application/pdf") {
        this.hasError = false;
        this.fileSizeError = false;
        this.fileTypeError = true;
      } else if (fileUploaded.size > 5042157) {
        this.fileTypeError = false;
        this.hasError = false;
        this.fileSizeError = true;
      } else {
        this.fileSizeError = false;
        this.fileTypeError = false;

        if (typeof FileReader !== "undefined") {
          let reader = new FileReader();
          reader.onload = (e: any) => {
            this.pdfSrc = e.target.result;
            //console.log(this.pdfSrc);
          };
          let $file: any = fileUploaded;
          reader.readAsArrayBuffer($file);
        }

        this.extractedledger.patchValue({
          fileSource: fileUploaded,
        });

        this.hasError = false;
        this.isInvoiceChange = true;

        const userData = {
          req: {
            emailAddress: this.extractedledger.value.emailAddress,
            companyCode: this.extractedledger.value.companyCode,
            purchaseOrg: this.extractedledger.value.purchaseOrg,
            docType: this.extractedledger.value.docType,
            items: [{ poNo: "", itemNo: "", grn: "" }],
          },
        };

        this.loading = true;
        this.invoiceChanged = true;
        this.formSubmitted = true;

        //console.log(userData);

        //console.log(localStorage.getItem("eippSession"));

        const formData: any = new FormData();
        // formData.append('poNo', this.route.snapshot.params['poNo']);
        formData.append("sellerCode", localStorage.getItem("vendorCode"));
        formData.append("sessionId", localStorage.getItem("eippSession"));
        formData.append("invoiceType", "e-invoice");
        formData.append("req", JSON.stringify(userData.req));
        formData.append("file", this.extractedledger.value.fileSource);

        // for (const value of formData.values()) {
        //     console.log(value);
        // }

        this.eLoaderMsg = "Verifying QR Code";

        setTimeout(() => {
          this.eLoaderMsg = "Authenticating QR Code";
        }, 5000);
        setTimeout(() => {
          this.eLoaderMsg = "Extracting Data";
        }, 10000);
        setTimeout(() => {
          this.eLoaderMsg = "Validating Data";
        }, 15000);

        this.invoiceService.extractInvoice(formData).subscribe(
          (res) => {
            this.loading = false;
            this.invoiceChanged = false;
            this.isUpdatedData = true;
            this.responseData = res;
            this.formSubmitted = false;
            //console.log(res);
            if (this.responseData.length !== 0 && this.responseData.status === "error") {
              console.log(this.responseData.message);
            } else {
              //console.log("Success hereresponseData");
              this.invoiceDetails = this.responseData;
            }
          },
          (error) => {
            console.log(error.msg);
          }
        );
      }
    }
  }

  onDrop(event: any) {
    // Update the list order
    moveItemInArray(this.supportingDocuments, event.previousIndex, event.currentIndex);
    this.supportingDocsAdded = true;
  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  fetchConfig() {
    const config: any = this.invoiceService.getAllConfig();
    this.configResOrg = config.purchaseOrganizations;
    this.configResCompanies = config.companyCodes;
    this.configResDocs = config.purchaseDoc;
  }

  fetchPurchaseOrg() {
    const configReq = {
      configType: "purchaseOrganizations",
      sellerCode: localStorage.getItem("vendorCode"),
      session: {
        sessionId: localStorage.getItem("eippSession"),
      },
    };

    this.invoiceService.fetchConfig(configReq).subscribe(
      (res) => {
        this.configResOrg = res;
        if (this.configResOrg.length !== 0 && this.configResOrg.status === "error") {
          console.log(this.configResOrg + " Error");
        } else {
          this.organisations = this.configResOrg.data;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  fetchCompanyCode() {
    const configReq = {
      configType: "companyCodes",
      sellerCode: localStorage.getItem("vendorCode"),
      session: {
        sessionId: localStorage.getItem("eippSession"),
      },
    };

    this.invoiceService.fetchConfig(configReq).subscribe(
      (res) => {
        this.configResCompanies = res;
        if (this.configResCompanies.length !== 0 && this.configResCompanies.status === "error") {
          console.log(this.configResCompanies + " Error");
        } else {
          this.companies = this.configResCompanies.data;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  fetchDocType() {
    const configReq = {
      configType: "purchaseDoc",
      sellerCode: localStorage.getItem("vendorCode"),
      session: {
        sessionId: localStorage.getItem("eippSession"),
      },
    };

    this.invoiceService.fetchConfig(configReq).subscribe(
      (res) => {
        this.configResDocs = res;
        if (this.configResDocs.length !== 0 && this.configResDocs.status === "error") {
          console.log(this.configResDocs + " Error");
        } else {
          this.docs = this.configResDocs.data;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  onLedgerSubmit() {
    this.loading = true;
    this.uploadInvoice = true;
    this.formSubmitted = true;

    let username = this.invoiceService.getUsername();
    let userID = this.invoiceService.getUserId();
    let poNo = this.invoiceService.getPo();

    const userData = {
      companyCode: this.invoiceDetails.company_code,
      purchaseOrg: this.invoiceDetails.purchase_org,
      docType: this.invoiceDetails.doc_type,
      emailAddress: this.invoiceDetails.email_address,
      poNo: poNo,
      username: username,
      userId: userID,
      items: [
        {
          barcode: "",
          poNo: this.invoiceDetails.poNo,
          itemNo: "",
          grn: "",
        },
      ],
      termsAgreed: true,
      vesselNumber: "",
      vesselName: "",
    };

    if (this.isInvoiceChange === true) {
      this.invoiceFile = this.extractedledger.value.fileSource;
    } else {
      this.invoiceFile = this.invoiceService.getFileElement();
    }

    const trimNo = this.invoiceDetails.invoice_number.replace(/\s+/g, "");

    const mapKeys = {
      file_link: this.invoiceDetails.file_link,
      SellerGstin: this.invoiceDetails.gstin,
      BuyerGstin: "",
      DocNo: trimNo,
      DocTyp: this.invoiceService.getNoteType(),
      DocDt: this.invoiceDetails.invoice_date,
      TotInvVal: this.invoiceDetails.invoice_amount,
      ItemCnt: "",
      MainHsnCode: "",
      Irn: this.invoiceDetails.irn,
      IrnDt: "",
      invType: this.invoiceService.getInvType(),
      invoiceType: this.invoiceService.getInvoiceType(),
    };

    const fileOrder = [];
    this.supportingDocuments.forEach((file, index) => {
      const obj = {};
      obj[(index + 1).toString()] = file.name;
      fileOrder.push(obj);
    });

    // Create ledger array similar to ds-ledger-preview
    const timestamp = Date.now();
    const ledger = [
      {
        docDate: this.dateUtils.formatDateString(this.invoiceDetails.invoice_date),
        dueDate: this.dateUtils.formatDateString(this.invoiceDetails.invoice_date),
        dueAmt: parseFloat(this.invoiceDetails.invoice_amount),
        docAmt: parseFloat(this.invoiceDetails.invoice_amount),
        docType: "APINV",
        poNo: this.invoiceDetails.poNo,
        docNo: trimNo,
        timestamp: timestamp,
        currCode: "INR",
        status: "PENDING_SUBMISSION",
        barcodePrefix: this.invoiceDetails.barcodePrefix,
        supplierNm: localStorage.getItem("displayName"),
        docDetail: {
          docAmt: this.invoiceDetails.invoice_amount,
          docFormat: "e-invoice",
          docCat: "po_based",
          docGstin: this.invoiceDetails.gstin,
          irn: this.invoiceDetails.irn,
        },
        docRef: [
          {
            src: this.invoiceDetails.file_link,
          },
        ],
        lineItemDetail: [],
        supplierCode: localStorage.getItem("vendorCode"),
        cmpCode: this.invoiceDetails.company_code,
        purchaseOrg: this.invoiceDetails.purchase_org,
        erpDocType: this.invoiceDetails.doc_type,
        email: this.invoiceDetails.email_address,
      },
    ];

    //console.log(localStorage.getItem("eippSession"));

    const formData: any = new FormData();
    formData.append("sellerCode", this.authService.getSellerCode());
    formData.append("reqType", "payexap");
    formData.append(
      "session",
      JSON.stringify({
        sessionId: localStorage.getItem("eippSession"),
      })
    );
    formData.append("action", "add");
    formData.append("ledger", JSON.stringify(ledger));

    if (this.supportingDocuments.length !== 0) {
      for (let i = 0; i < this.supportingDocuments.length; i++) {
        formData.append("supportingDocs", this.supportingDocuments[i]);
      }
    } else {
      formData.append("supportingDocs", this.supportingDocuments);
    }

    // for (const value of formData.values()) {
    //     console.log(value + " This is formdata");
    // }

    this.invoiceService.uploadInvoiceWithoutExtration(formData).subscribe(
      (res) => {
        this.responseData = res;
        //console.log(this.responseData.status);

        if (this.responseData.status === "error") {
          console.log("error exist");
          this.loading = false;
          this.uploadInvoice = false;
          this.hasError = true;
          this.formSubmitted = false;
        } else {
          this.barcodeNo = this.responseData.barcode;
          let docType;
          if (localStorage.getItem("document") === "Credit Note") {
            docType = "CN";
          } else {
            docType = "DN";
          }
          const data = {
            barcode: this.barcodeNo,
            docTyp: docType,
            sellerCode: localStorage.getItem("vendorCode"),

            session: {
              sessionId: localStorage.getItem("eippSession"),
            },
          };
          //console.log(data);

          this.invoiceService.sendInvoiceToJSW(data).subscribe(
            (res) => {
              console.log(res);
            },
            (error) => {
              console.log(error);
            }
          );
          console.log("Success");

          this.uploadSuccessful = true;
          this.uploadInvoice = false;
        }
      },
      (error) => {
        this.uploadInvoice = false;
        this.uploadSuccessful = false;
        this.invoiceSaved = false;
        this.serverError = true;
        // console.log(error);
      }
    );

    this.modalService.dismissAll();
    //
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    this.invoiceDetails = this.invoiceService.getProcessedInvoice();
    this.formSubmitted = false;

    this.fetchConfig();
    // this.fetchPurchaseOrg();
    // this.fetchDocType();

    console.log(this.companies);
    console.log(this.invoiceDetails);

    this.extractedledger.patchValue({
      purchaseOrg: this.invoiceDetails.purchase_org,
      docType: this.invoiceDetails.doc_type,
      emailAddress: this.invoiceDetails.email_address.toLowerCase(),
      companyCode: parseInt(this.invoiceDetails.company_code),
      username: this.invoiceService.getUsername(),
      userID: this.invoiceService.getUserId(),
    });
    this.loadFile();

    // console.log(this.extractedledger);
    // console.log("Form Data");

    //this.pdfSrc = this.invoiceService.getInvoiceFile();
    //console.log(this.pdfSrc);
    ///this.imgUrl = this.invoiceDetails.file_link;

    // if (this.invoiceDetails.raw.errors.length !== 0) {
    //     this.hasError = true;
    // } else {
    //     this.hasError = false;
    // }

    //console.log(this.invoiceDetails);
  }

  closeSuccessDialog() {
    this.loading = false;
    this.router.navigateByUrl("/credit-notes");
  }

  closeErrorDialog() {
    this.loading = false;
    this.savingError = false;
    this.serverError = false;
  }

  resubmitInvoice() {
    this.router.navigateByUrl("/submit-nonpo-invoice");
  }

  onCheckboxChange(e: any) {
    //console.log(e);
    if (e.target.checked) {
      this.extractedledger.patchValue({
        terms_agreed: e.target.value,
      });
    } else {
      this.extractedledger.patchValue({
        terms_agreed: null,
      });
    }
  }

  loadFile() {
    if (typeof FileReader !== "undefined") {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
        //console.log(this.pdfSrc);
      };
      let $file: any = this.invoiceService.getFileElement();
      reader.readAsArrayBuffer($file);
    }

    // this.invoiceFile = new Blob([this.pdfSrc], { type: "application/pdf" });
  }

  viewSavedInvoices() {
    this.router.navigate(["/saved-invoices"]);
  }
}
